const fa = {
  translation: {
    "% Of times": "% Du temps",
    "Accounts Manager": "Gestionnaire de comptes",
    "Action": "Action",
    "Actions": "Actions",
    "Active": "Actif",
    "Active Campaigns": "Campagnes actives",
    "Add New Account": "Ajouter un nouveau compte",
    "Add Task": "Ajouter une tâche",
    "Add new": "Ajouter nouveau",
    "Add the new URL": "Ajouter la nouvelle URL",
    "Add the new keyword": "Ajouter le nouveau mot-clé",
    "Add the new tag": "Ajouter la nouvelle étiquette",
    "Advance Options": "Options avancées",
    "Advance Setting": "Paramètre avancé",
    "Advanced Clicking": "Clic avancé",
    "Advanced Functions": "Fonctions avancées",
    "Advanced Image Editor": "Éditeur d'image avancé",
    "All": "Tout",
    "All settings": "Tous les paramètres",
    "An unexpected error has occurred": "Une erreur inattendue s'est produite",
    "Are you sure to clear all caches?": "Êtes-vous sûr de vouloir effacer tous les caches ?",
    "Are you sure to clear the accounts list?": "Êtes-vous sûr de vouloir effacer la liste des comptes ?",
    "Are you sure to clone this campaign?": "Êtes-vous sûr de vouloir cloner cette campagne ?",
    "Are you sure to delete this campaign?": "Êtes-vous sûr de vouloir supprimer cette campagne ?",
    "Are you sure to delete this thread?": "Êtes-vous sûr de vouloir supprimer ce fil de discussion ?",
    "Are you sure to remove the campaign(s)?": "Êtes-vous sûr de vouloir supprimer la(les) campagne(s) ?",
    "Are you sure to remove the proxies?": "Êtes-vous sûr de vouloir supprimer les mandataires ?",
    "Are you sure to reset settings?": "Êtes-vous sûr de vouloir réinitialiser les paramètres ?",
    "Are you sure to restart the campaign(s)?": "Êtes-vous sûr de vouloir redémarrer la(les) campagne(s) ?",
    "Are you sure to these changes?": "Êtes-vous sûr de vouloir effectuer ces changements ?",
    "Attribute": "Attribut",
    "Available days": "Jours disponibles",
    "Avg Daily Visitors": "Visiteurs quotidiens moyens",
    "Avg Visitor Duration": "Durée moyenne de la visite",
    "Back": "Retour",
    "Back To Campaigns": "Retour aux campagnes",
    "Block Images": "Bloquer les images",
    "Block Resources": "Bloquer les ressources",
    "Block the campaign until VPN gets connected": "Bloquer la campagne jusqu'à ce que le VPN soit connecté",
    "Browse Result Pages": "Parcourir les pages de résultats",
    "Browser Profile": "Profil du navigateur",
    "Browser Type": "Type de navigateur",
    "Buy a license key": "Acheter une clé de licence",
    "CTR": "CTR",
    "CType": "CType",
    "Cache cleared successfully": "Cache effacé avec succès",
    "Calendar": "Calendrier",
    "Camp Settings": "Paramètres de campagne",
    "Campaign name": "Nom de la campagne",
    "Campaign to clone": "Campagne à cloner",
    "Campaigns": "Campagnes",
    "Chance": "Chance",
    "Change point": "Changer le point",
    "Changed successfully": "Modifié avec succès",
    "Choose": "Choisir",
    "Choose an action": "Choisir une action",
    "Choose file": "Choisir un fichier",
    "Choose the file to import": "Choisir le fichier à importer",
    "Clear": "Effacer",
    "Clear List": "Effacer la liste",
    "Clear all caches": "Effacer tous les caches",
    "Click Here": "Cliquez ici",
    "Click on the map and move the pointer": "Cliquez sur la carte et déplacez le pointeur",
    "Clicking Chance (CTR)": "Chances de clic (CTR)",
    "Clone": "Cloner",
    "Clone Selected": "Cloner la sélection",
    "Complete": "Complet",
    "Congratulations": "Félicitations",
    "Connect your device to your computer/laptop via USB": "Connectez votre appareil à votre ordinateur/ordinateur portable via USB",
    "Connection Type": "Type de connexion",
    "Copyright DalgaDev": "Droits d'auteur DalgaDev",
    "Country": "Pays",
    "Create new Campaign": "Créer une nouvelle campagne",
    "Created Campaigns": "Campagnes créées",
    "Creation Date": "Date de création",
    "Custom CSS Selector (it will ignore the settings made above)": "Sélecteur CSS personnalisé (il ignorera les paramètres ci-dessus)",
    "Custom Xpath Selector (it will ignore the settings made above)": "Sélecteur Xpath personnalisé (il ignorera les paramètres ci-dessus)",
    "Dashboard": "Tableau de bord",
    "Dear User": "Cher utilisateur",
    "Debug Logs": "Journaux de débogage",
    "Delay Between": "Délai entre",
    "Delay between campaigns": "Délai entre les campagnes",
    "Delay on the main webpage": "Délai sur la page principale",
    "Description about latest camps and more …": "Description des derniers camps et plus encore …",
    "Desktop": "Bureau",
    "Device Name": "Nom de l'appareil",
    "Devices": "Appareils",
    "Direct Traffic": "Trafic direct",
    "Do you want the accounts of this profile to be replaced by the following accounts?": "Voulez-vous que les comptes de ce profil soient remplacés par les comptes suivants ?",
    "Do you want to save the accounts on the selected profile before closing the window?": "Voulez-vous enregistrer les comptes sur le profil sélectionné avant de fermer la fenêtre ?",
    "Don't block in these urls": "Ne pas bloquer dans ces URL",
    "Edit": "Éditer",
    "Edit Image": "Éditer l'image",
    "Edit Selected": "Modifier la sélection",
    "Edit Task": "Modifier la tâche",
    "Edit in bulk": "Modifier en masse",
    "Element": "Élément",
    "Email": "E-mail",
    "Enter RSS feed URL here": "Saisissez l'URL du flux RSS ici",
    "Enter Sitemap URL here": "Entrez l'URL du plan du site ici",
    "Enter group name": "Entrez le nom du groupe",
    "Enter the URL to import": "Entrez l'URL à importer",
    "Enter the port": "Entrez le port",
    "Enter your license key": "Entrez votre clé de licence",
    "Error": "Erreur",
    "Explore key details about your most recent campaigns": "Explorez les détails clés de vos campagnes les plus récentes",
    "Export": "Exporter",
    "External links": "Liens externes",
    "Fast": "Rapide",
    "Features & Actions": "Fonctionnalités et Actions",
    "Fix Error": "Corriger l'erreur",
    "From": "De",
    "Full debugging mode": "Mode de débogage complet",
    "GO BACK": "RETOUR",
    "GPS Simulation": "Simulation GPS",
    "Generate Selectors Automatically": "Générer automatiquement les sélecteurs",
    "Go to Campaigns": "Aller aux campagnes",
    "Google Account": "Compte Google",
    "Google Map": "Carte Google",
    "How many pages should the bot visit in each session?": "Combien de pages le bot devrait-il visiter à chaque session ?",
    "How many seconds should IP visit other subpage?": "Au bout de combien de secondes l'IP devrait-elle visiter une autre sous-page ?",
    "How would you like threads to operate?": "Comment souhaitez-vous que les fils fonctionnent ?",
    "I accept the agreement": "J'accepte l'accord",
    "If a configuration file doesn't work skip it and try another file": "Si un fichier de configuration ne fonctionne pas, ignorez-le et essayez un autre fichier",
    "Import": "Importer",
    "Import (Seperate by line)": "Importer (séparer par ligne)",
    "Import From File": "Importer depuis un fichier",
    "Import Options": "Options d'importation",
    "Import Proxy": "Importer un proxy",
    "Import selected": "Importer la sélection",
    "Import the websites in bulk (Seperate by line)": "Importer les sites Web en vrac (séparer par ligne)",
    "Imported successfully": "Importé avec succès",
    "Inactive": "Inactif",
    "Input your text": "Saisissez votre texte",
    "Internal links": "Liens internes",
    "Keyword": "Mot-clé",
    "Keywords": "Mots-clés",
    "Lan": "Langue",
    "Last Status": "Dernier statut",
    "Latest Campaigns": "Dernières campagnes",
    "Learn More": "En savoir plus",
    "Less": "Moins",
    "License": "Licence",
    "License Key": "Clé de licence",
    "Link": "Lien",
    "Load File": "Charger un fichier",
    "Load URL": "Charger une URL",
    "Log all activities": "Journaliser toutes les activités",
    "Logout": "Se déconnecter",
    "Make sure at least one task is added": "Assurez-vous qu'au moins une tâche est ajoutée",
    "Manage Account": "Gérer le compte",
    "Message": "Message",
    "Mobile": "Mobile",
    "Mode": "Mode",
    "Modify": "Modifier",
    "More": "Plus",
    "Multi Thread": "Multithread",
    "Multi Threading": "Multithreading",
    "Name": "Nom",
    "Name Of Business": "Nom de l'entreprise",
    "Never show notification at top": "Ne jamais afficher la notification en haut",
    "New Task": "Nouvelle tâche",
    "Newest": "Plus récent",
    "No Keyword/websites were found to import": "Aucun mot-clé/site Web n'a été trouvé pour l'importation",
    "No file chosen": "Aucun fichier choisi",
    "No notification found": "Aucune notification trouvée",
    "No thread found": "Aucun fil trouvé",
    "NordVPN": "NordVPN",
    "Notifications": "Notifications",
    "Number of visitors": "Nombre de visiteurs",
    "OR": "OU",
    "Oldest": "Plus ancien",
    "OpenVPN files directory": "Répertoire des fichiers OpenVPN",
    "Order By": "Trier par",
    "Other VPN (Manual)": "Autre VPN (Manuel)",
    "Overview": "Aperçu",
    "Overwrite": "Écraser",
    "Pages": "Pages",
    "Password": "Mot de passe",
    "Please accept the agreement": "Veuillez accepter l'accord",
    "Please choose the mode you want to use": "Veuillez choisir le mode que vous souhaitez utiliser",
    "Please fill the format and protocol": "Veuillez remplir le format et le protocole",
    "Point set successfully!": "Point défini avec succès !",
    "Port": "Port",
    "Previous Step": "Étape précédente",
    "Profiles": "Profils",
    "Protocol": "Protocole",
    "Proxy": "Proxy",
    "Put the app in windows start up": "Ajoutez l'application au démarrage de Windows",
    "Quick Update": "Mise à jour rapide",
    "Reactive the bot with another purchase code": "Réactivez le bot avec un autre code d'achat",
    "Recent logs": "Journaux récents",
    "Recovery Email": "E-mail de récupération",
    "Remove": "Supprimer",
    "Remove All": "Tout supprimer",
    "Remove Group": "Supprimer le groupe",
    "Remove Selected": "Supprimer la sélection",
    "Remove non-functional proxies": "Supprimer les mandataires non fonctionnels",
    "Remove this device from the license key": "Supprimer cet appareil de la clé de licence",
    "Report": "Rapport",
    "Reset and clear all campaigns and their settings": "Réinitialiser et effacer toutes les campagnes et leurs paramètres",
    "Restart": "Redémarrer",
    "Restart All": "Tout redémarrer",
    "Restart Selected": "Redémarrer la sélection",
    "SE": "Moteur de recherche",
    "Save": "Enregistrer",
    "Save Profile": "Enregistrer le profil",
    "Saved successfully": "Enregistré avec succès",
    "Schedule": "Programme",
    "Scheduled Camp": "Campagne planifiée",
    "Scroll": "Faire défiler",
    "Search": "Rechercher",
    "Search Engine": "Moteur de recherche",
    "Search Engine Domain": "Domaine du moteur de recherche",
    "Search Language": "Langue de recherche",
    "Seconds": "Secondes",
    "See All Notifications": "Voir toutes les notifications",
    "Select Airplane mode icon": "Sélectionnez l'icône du mode avion",
    "Select Airplane mode icon on ATB": "Sélectionnez l'icône du mode Avion sur ATB",
    "Select Campaign": "Sélectionner la campagne",
    "Select Edit Mode": "Sélectionner le mode d'édition",
    "Select Profile Name": "Sélectionner le nom du profil",
    "Select a profile or enter a new profile name": "Sélectionnez un profil ou saisissez un nouveau nom de profil",
    "Select from": "Sélectionner depuis",
    "Select or enter a new profile": "Sélectionner ou saisir un nouveau profil",
    "Select the website that you want visitors to be referred from": "Sélectionnez le site Web à partir duquel vous souhaitez renvoyer les visiteurs",
    "Sent Visitors": "Visiteurs envoyés",
    "Sent views": "Vues envoyées",
    "Session": "Session",
    "Settings": "Paramètres",
    "Settings reset successfully": "Réinitialisation des paramètres réussie",
    "Slow": "Lent",
    "Social Media": "Médias sociaux",
    "Sorry, page not found!": "Désolé, page introuvable !",
    "Speed": "Vitesse",
    "Start": "Démarrer",
    "Start All": "Démarrer tout",
    "Start Minimized": "Démarrer réduit",
    "Start Selected": "Démarrer la sélection",
    "Start sending traffic as soon as the app comes up": "Commencez à envoyer du trafic dès que l'application démarre",
    "Statistics": "Statistiques",
    "Status": "Statut",
    "Stop": "Arrêter",
    "Stop All": "Arrêter tout",
    "Stop Selected": "Arrêter la sélection",
    "Submit": "Soumettre",
    "Tablet": "Tablette",
    "Tags": "Balises",
    "Task Not Found": "Tâche non trouvée",
    "Tasks": "Tâches",
    "Test Proxy": "Tester le proxy",
    "Test Proxy Result": "Résultat du test du proxy",
    "The action was successfully done": "L'action a été réalisée avec succès",
    "The bot was deactivated": "Le bot a été désactivé",
    "The campaign cloned successfully": "La campagne a été clonée avec succès",
    "The campaign has been modified": {
      " Cliquez pour enregistrer les modifications": " Cliquez pour enregistrer les modifications"
    },
    "The campaign(s) removed successfully": "La ou les campagnes ont été supprimées avec succès",
    "The campaign(s) restarted successfully": "La ou les campagnes ont été redémarrées avec succès",
    "The campaign(s) started successfully": "La ou les campagnes ont été lancées avec succès",
    "For instance: if you have 30 campaigns to send traffic to and you choose 30 threads,": "Par exemple : si vous avez 30 campagnes pour envoyer du trafic et que vous choisissez 30 fils,",
    "each thread will initiate from the first campaign and it will process campaigns until the last one.": "chaque fil commencera par la première campagne et traitera les campagnes jusqu'à la dernière.",
    "each thread will have a different campaign assigned (first thread will send traffic to the first campaign,": "chaque fil aura une campagne différente assignée (le premier fil enverra du trafic vers la première campagne,",
    "second thread to the second campaign, and so forth)": "le deuxième fil à la deuxième campagne, et ainsi de suite)",
    "Visit": "Visiter",
    "referrer": "référent",
    "Update Camp": "Mettre à jour la campagne",
    "In Order": "En ordre",
    "Randomised": "Aléatoire",
    "try to play online videos": "essayer de lire des vidéos en ligne",
    "if Url": "si l'URL",
    "Click": "Cliquer",
    "Equal": "Égal",
    "Contain": "Contenir",
    "Then": "Ensuite",
    "Inject JS": "Injecter du JS",
    "Total Visitors": "Nombre total de visiteurs",
    "Inject Cookie": "Injecter un cookie",
    "Logs": "Journaux",
    "Threads": "Fils",
    "Help": "Aide",
    "About": "À propos",
    "Type": "Type",
    "Not Found": "Non trouvé",
    "Search Engine Traffic": "Trafic moteur de recherche",
    "URL": "URL",
    "What do you want to export?": "Que voulez-vous exporter ?",
    "Sleeping": "Endormi",
    "Visitor": "Visiteur",
    "Assign all campaigns to all of threads. Threads will start sending visitor from the first campaign all together.": "Attribuer toutes les campagnes à tous les fils. Les fils commenceront à envoyer des visiteurs à partir de la première campagne tous ensemble.",
    "Assign different campaigns to threads. Threads will start sending visitors from different campaigns.": "Attribuer différentes campagnes aux fils. Les fils commenceront à envoyer des visiteurs à partir de différentes campagnes.",
    "This field must be filled in!": "Ce champ doit être rempli !",
    "Update Campaign": "Mettre à jour la campagne",
    "What we should call your campaign and more …": "Comment devrions-nous appeler votre campagne et plus encore...",
    "User-agent Device Percentage": "Pourcentage d'appareils avec l'agent utilisateur",
    "Video and Audio": "Vidéo et audio",
    "Unlimited": "Illimité",
    "To": "À",
    "Image": "Image",
    "CSS (Stylesheet)": "CSS (Feuille de style)",
    "Font": "Police",
    "Script (js codes)": "Script (codes JS)",
    "What to do?": "Que faire ?",
    "What to do with browser directories?": "Que faire avec les répertoires du navigateur ?",
    "If you want to re-use the profiles later, you'll need to save the browser profiles": "Si vous souhaitez réutiliser les profils plus tard, vous devrez enregistrer les profils du navigateur",
    "Next Step": "Étape suivante",
    "Your campaign is updated successfully": "Votre campagne a été mise à jour avec succès",
    "Start Type": "Type de démarrage",
    "Specific Date": "Date spécifique",
    "Day Of week": "Jour de la semaine",
    "Every day": "Chaque jour",
    "Start Date": "Date de début",
    "Start Time": "Heure de début",
    "End Type": "Type de fin",
    "End Date": "Date de fin",
    "End Time": "Heure de fin",
    "Default Settings": "Paramètres par défaut",
    "Custom Settings": "Paramètres personnalisés",
    "Create new profiles": "Créer de nouveaux profils",
    "Use previous profiles": "Utiliser les profils précédents",
    "Campaigns overview": "Aperçu des campagnes",
    "You should enable logging all activities to get detailed reports.": "Vous devez activer l'enregistrement de toutes les activités pour obtenir des rapports détaillés.",
    "Visitor(s)": "Visiteur(s)",
    "no directory chosen": "aucun répertoire choisi",
    "You need to download openvpn files (configs) from your VPN's website and place the config files into a directory and select it by the ATB": "Vous devez télécharger les fichiers OpenVPN (configs) depuis le site Web de votre VPN et placer les fichiers de configuration dans un répertoire, puis le sélectionner avec l'ATB",
    "Username": "Nom d'utilisateur",
    "Please follow these steps to configure your android phone to use it with the bot:": "Veuillez suivre ces étapes pour configurer votre téléphone Android afin de l'utiliser avec le bot :",
    "Turn On USB Debugging ( and USB Security Debugging on Xiaomi Phones ).": "Activez le débogage USB (et le débogage de sécurité USB sur les téléphones Xiaomi).",
    "Accept Authorization Request on your mobile. ( Select Always Checkbox as well)": "Acceptez la demande d'autorisation sur votre mobile. (Sélectionnez également la case Toujours)",
    "Wait time between toggling airplan mode (seconds)": "Temps d'attente entre les basculements du mode avion (en secondes)",
    "Turn Off Your WiFi and Turn On USB Tethering": "Éteignez votre WiFi et activez le partage de connexion USB",
    "Ensure your phone screen stays active while using the application.":"Assurez-vous que l'écran de votre téléphone reste actif pendant l'utilisation de l'application",
    "Your Device model is {{deviceName}} with android version {{version}} and not rooted": "Votre modèle d'appareil est {{deviceName}} avec la version Android {{version}} et n'est pas rooté",
    "Are you sure you want to deactivate the bot on this device? This will not remove the device from activated devices list.": "Êtes-vous sûr de vouloir désactiver le bot sur cet appareil? Cela ne retirera pas l'appareil de la liste des appareils activés.",
    "No": "Non",
    "Yes": "Oui",
    "Enter your license key or purchase code.": "Entrez votre clé de licence ou code d'achat.",
    "Verify": "Vérifier",
    "Actions to Perform on the Maps Listing":"Actions à Effectuer sur la Liste des Cartes",
    "Business Name":"Nom de l'entreprise"                
  },
};

export default fa;
